import React, { useEffect, useState } from 'react';
import { DatePicker, Form, message, Modal, Row, Select, Switch } from 'antd';
import { FormItemWrap, configManager } from 'react-structure-admin';
import moment from 'moment';
import { ResCol } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import {
  closeResendInvoice,
  postResendInvoice
} from 'stores/financialEntries/financialEntryActions';

const FinancialEntryResendEmailInternal = ({ saving, data }) => {
  const dispatch = useDispatch();
  const { financialEntry } = data;
  const [form] = Form.useForm();
  const [required, setRequired] = useState(true);

  const handleSuccess = () => {
    message.success('Enviado com sucesso.');
  };

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      dispatch(
        postResendInvoice(
          { ...values, id: financialEntry.invoice?.id },
          handleSuccess
        )
      );
    });
  };

  const handleClose = () => {
    form.resetFields();
    dispatch(closeResendInvoice());
  };

  const emailValidator = (_, value) => {
    if (value?.length > 5) {
      return Promise.reject(new Error('Maximo de 10 e-mails'));
    }

    return Promise.resolve();
  };

  useEffect(() => {
    if (financialEntry.patient?.email) {
      form.setFieldsValue({ emails: [financialEntry.patient?.email] });
    }
  }, []);

  const handleValuesChange = (_, { allowSendByApp }) => {
    setRequired(!allowSendByApp);
  };

  return (
    <Modal
      title="Enviar para o paciente"
      visible
      onCancel={handleClose}
      onOk={handleSubmit}
      cancelText="Voltar"
      okText="Enviar"
      width={450}
      confirmLoading={saving}
    >
      <Form
        form={form}
        {...configManager.getConfig().layout.form}
        onValuesChange={handleValuesChange}
      >
        <Row>
          <ResCol span={24}>
            <Form.Item
              name="emails"
              label="E-mails"
              rules={[
                {
                  required,
                  message: 'E-mail é obrigatório.'
                },
                { validator: emailValidator }
              ]}
            >
              <Select mode="tags" />
            </Form.Item>
          </ResCol>
        </Row>
        <Row>
          <ResCol span={24}>
            <FormItemWrap
              name="allowSendByApp"
              labelAlign="center"
              label="Enviar nota fiscal para o app da Kuidare"
              valuePropName="checked"
              hidden={!financialEntry.patient?.userId}
            >
              <Switch />
            </FormItemWrap>
          </ResCol>
        </Row>
      </Form>
    </Modal>
  );
};

const FinancialEntryResendEmail = () => {
  const { resendEmailData = false, saving = false } = useSelector(
    (state) => state.resources?.['financial-entries'] ?? {}
  );

  if (!resendEmailData) {
    return null;
  }

  return (
    <FinancialEntryResendEmailInternal saving={saving} data={resendEmailData} />
  );
};

export default FinancialEntryResendEmail;
